module.exports = __webpack_public_path__ + "img/honor_003.30e9ce3.png";